export function doStyleOnAllOrderingPages() {
    $('.ordering-process .cart-content .checkout-box .toggle-contacts').addClass('expanded');
    $('.ordering-process .cart-content .checkout-box .box-bg-default').addClass('visible');
}
